import React, { Component } from 'react'
import Helmet from 'react-helmet'
import CaseStudyHeader from '../components/case-studies/case-study-header'
import NextProject from '../components/case-studies/next-project'
import { renderComponent } from '../components/common/render-components.js'
import WithData from '../components/common/with-data.js'
import Accordion from '../components/shared-page-components/accordion'
import { DivWithBackgroundColor } from '../components/shared-page-components/styled-components.js'
import '../assets/stylesheets/case-study.scss'

class CaseStudy extends Component {
  render() {
    const {
      title,
      slug,
      metaPageTitle,
      metaPageDescription,
      metaImage,
      metaImageTwitter,
      caseStudyBackgroundColor,
      caseStudyPrimaryColor,
      caseStudySecondaryColor,
      displayTitle,
      headerDisplayTitleFont,
      headerLayout,
      heroImageObject,
      heroVideoObject,
      heroImageCrop,
      introductionText,
      industry,
      services,
      processComponents,
      contentComponents,
      nextProject,
      nextProjectTintColor,
      nextProjectFontColor,
    } = this.props

    function addColorsToComponents(component) {
      component.primaryColor = caseStudyPrimaryColor
      component.secondaryColor = caseStudySecondaryColor
      component.backgroundColor = caseStudyBackgroundColor
    }

    contentComponents.map(component => {
      return addColorsToComponents(component)
    })

    processComponents.map(component => {
      return addColorsToComponents(component)
    })

    const PageMetaContent = () => (
      <Helmet>
        <title>{metaPageTitle}</title>
        <meta property="og:title" content={metaPageTitle} />
        <meta property="twitter:title" content={metaPageTitle} />
        <meta name="description" content={metaPageDescription} />
        <meta property="og:description" content={metaPageDescription} />
        <meta property="twitter:description" content={metaPageDescription} />
        <meta
          property="og:image"
          content={`${metaImage.file.url}?w=1200&h=630&fit=fill&fm=jpg&q=90`}
        />
        <meta
          property="twitter:image"
          content={`${
            metaImageTwitter.file.url
          }?w=800&h=418&fit=fill&fm=jpg&q=90`}
        />
        <meta
          name="og:url"
          content={`${process.env.GATSBY_SITE_BASE_URL}/case-study/${slug}`}
        />
      </Helmet>
    )

    return (
      <DivWithBackgroundColor
        id="case-study"
        className={headerLayout}
        backgroundColor={caseStudyBackgroundColor}
      >
        <PageMetaContent />
        <CaseStudyHeader
          caseStudyBackgroundColor={caseStudyBackgroundColor}
          caseStudyPrimaryColor={caseStudyPrimaryColor}
          caseStudySecondaryColor={caseStudySecondaryColor}
          displayTitle={displayTitle}
          headerDisplayTitleFont={headerDisplayTitleFont}
          heroImageObject={heroImageObject}
          heroVideoObject={heroVideoObject}
          heroImageCrop={heroImageCrop}
          headerLayout={headerLayout}
          introductionText={introductionText}
          industry={industry}
          services={services}
          title={title}
        />

        {processComponents[0].__typename && (
          <div id="accordion-component">
            <Accordion
              primaryColor={caseStudyPrimaryColor}
              secondaryColor={caseStudySecondaryColor}
              backgroundColor={caseStudyBackgroundColor}
              panels={[
                {
                  label: <h2>See Our Process</h2>,
                  closeLabel: <h2>Close Process</h2>,
                  content: processComponents.map((component, i) => {
                    return renderComponent(component, i)
                  }),
                },
              ]}
            />
          </div>
        )}

        <DivWithBackgroundColor backgroundColor={caseStudyBackgroundColor}>
          {contentComponents.map((component, i) => {
            return renderComponent(component, i)
          })}
        </DivWithBackgroundColor>

        {nextProject && (
          <NextProject
            nextProject={nextProject}
            nextProjectTintColor={nextProjectTintColor}
            nextProjectFontColor={nextProjectFontColor}
          />
        )}
      </DivWithBackgroundColor>
    )
  }
}

export default WithData(mapDataToProps, CaseStudy)

function handleHeroImageOrVideo(imageOrVideo) {
  const key =
    imageOrVideo[0].__typename === 'ContentfulHeroImage'
      ? 'heroImageObject'
      : 'heroVideoObject'

  return {
    [key]: imageOrVideo[0],
  }
}

function mapDataToProps(data) {
  const { contentfulCaseStudies } = data

  return {
    title: contentfulCaseStudies.title ? contentfulCaseStudies.title : '',
    slug: contentfulCaseStudies.slug ? contentfulCaseStudies.slug : '',
    metaPageTitle: contentfulCaseStudies.metaPageTitle || '',
    metaPageDescription:
      contentfulCaseStudies.metaPageDescription.metaPageDescription || '',
    metaImage: contentfulCaseStudies.metaImage
      ? contentfulCaseStudies.metaImage
      : { file: { url: '' } },
    metaImageTwitter: contentfulCaseStudies.metaImageTwitter
      ? contentfulCaseStudies.metaImageTwitter
      : { file: { url: '' } },
    caseStudyBackgroundColor: contentfulCaseStudies.caseStudyBackgroundColor
      ? contentfulCaseStudies.caseStudyBackgroundColor
      : '',
    caseStudyPrimaryColor: contentfulCaseStudies.caseStudyPrimaryColor
      ? contentfulCaseStudies.caseStudyPrimaryColor
      : '',
    caseStudySecondaryColor: contentfulCaseStudies.caseStudySecondaryColor
      ? contentfulCaseStudies.caseStudySecondaryColor
      : '',
    displayTitle: contentfulCaseStudies.displayTitle
      ? contentfulCaseStudies.displayTitle
      : '',
    headerDisplayTitleFont: contentfulCaseStudies.headerDisplayTitleFont
      ? contentfulCaseStudies.headerDisplayTitleFont
      : '',
    headerLayout: contentfulCaseStudies.headerLayout
      ? contentfulCaseStudies.headerLayout
      : '',
    ...handleHeroImageOrVideo(contentfulCaseStudies.heroImageOrVideo),
    heroImageCrop: contentfulCaseStudies.heroImageCrop
      ? contentfulCaseStudies.heroImageCrop
      : '',
    introductionText: contentfulCaseStudies.introductionText
      ? contentfulCaseStudies.introductionText
      : '',
    industry: contentfulCaseStudies.industry
      ? contentfulCaseStudies.industry
      : '',
    services: contentfulCaseStudies.services
      ? contentfulCaseStudies.services
      : '',
    processComponents: contentfulCaseStudies.processComponents
      ? contentfulCaseStudies.processComponents
      : [{}],
    contentComponents: contentfulCaseStudies.contentComponents
      ? contentfulCaseStudies.contentComponents
      : [{}],
    nextProject: contentfulCaseStudies.nextProject
      ? contentfulCaseStudies.nextProject
      : [{}],
    nextProjectTintColor: contentfulCaseStudies.nextProjectTintColor
      ? contentfulCaseStudies.nextProjectTintColor
      : '',
    nextProjectFontColor: contentfulCaseStudies.nextProjectFontColor
      ? contentfulCaseStudies.nextProjectFontColor
      : '',
  }
}

export const pageQuery = graphql`
  query caseStudyQuery($slug: String!) {
    contentfulCaseStudies(slug: { eq: $slug }) {
      title
      slug
      metaPageTitle
      metaPageDescription {
        metaPageDescription
      }
      metaImage {
        file {
          url
        }
      }
      metaImageTwitter {
        file {
          url
        }
      }
      caseStudyBackgroundColor
      caseStudyPrimaryColor
      caseStudySecondaryColor
      displayTitle
      headerDisplayTitleFont
      headerLayout
      heroImageOrVideo {
        ...heroImage
        ...heroVideo
      }
      heroImageCrop
      introductionText {
        introductionText
      }
      industry
      services
      processComponents {
        ...allImageBlocks
        ...allHalfImageBlocks
        ...allCarousels
        ...allQuotes
        ...allTextBlocks
        ...allVideosClickToPlay
        ...allVideosMutedAutoplay
      }
      contentComponents {
        ...allImageBlocks
        ...allHalfImageBlocks
        ...allCarousels
        ...allQuotes
        ...allTextBlocks
        ...allVideosClickToPlay
        ...allVideosMutedAutoplay
        ...allAccordions
      }
      nextProject {
        title
        slug
        footerImage {
          file {
            url
          }
        }
      }
      nextProjectTintColor
      nextProjectFontColor
    }
  }

  fragment allAccordions on ContentfulComponentAccordion {
    __typename
    title
    label
    closeLabel
    linkedComponents {
      ...allCarousels
      ...allHalfImageBlocks
      ...allImageBlocks
      ...allQuotes
      ...allTextBlocks
      ...allVideosClickToPlay
      ...allVideosMutedAutoplay
    }
    marginBelow
  }

  fragment heroImage on ContentfulHeroImage {
    __typename
    title
    heroImage {
      file {
        url
      }
    }
  }

  fragment heroVideo on ContentfulHeroVideo {
    __typename
    title
    videoUrl
    videoPosterImage {
      file {
        url
      }
    }
  }

  fragment allImageBlocks on ContentfulComponentImageBlock {
    __typename
    title
    image {
      file {
        url
      }
    }
    imageContentColumnWidth
    imageShiftContent
    captionTitle
    captionCopy {
      captionCopy
    }
    captionContentColumnWidth
    captionShiftContent
    marginBelow
  }

  fragment allHalfImageBlocks on ContentfulComponentHalfImageBlock {
    __typename
    title
    image {
      file {
        url
      }
    }
    imageAlign
    doesImageTakesFullWidthOnMobile
    captionTitle
    captionCopy {
      captionCopy
    }
    marginBelow
    captionAlign
  }

  fragment allCarousels on ContentfulComponentCarousel {
    __typename
    slides {
      title
      image {
        file {
          url
        }
      }
      captionTitle
      captionCopy {
        captionCopy
      }
    }
    marginBelow
  }

  fragment allQuotes on ContentfulComponentQuote {
    __typename
    title
    circleCroppedImage {
      file {
        url
      }
    }
    captionCopy {
      captionCopy
    }
    quoteAuthorOrSocialHandle
    contentColumnWidth
    shiftContent
    marginBelow
    linkToAuthorOrSocialMedia
  }

  fragment allTextBlocks on ContentfulComponentTextBlock {
    __typename
    title
    blockTitle
    blockCopy {
      blockCopy
    }
    textColor
    contentColumnWidth
    shiftContent
    marginBelow
  }

  fragment allVideosClickToPlay on ContentfulComponentVideoClickToPlay {
    __typename
    title
    vimeoUrl
    posterOverlayColor
    columnWidth
    alignment
    captionTitle
    captionAlignment
    marginBelow
    vimeoPosterImage {
      file {
        url
      }
    }
    captionCopy {
      captionCopy
    }
  }

  fragment allVideosMutedAutoplay on ContentfulComponentVideoMutedAutoplay {
    __typename
    title
    vimeoUrl
    columnWidth
    alignment
    captionTitle
    captionAlignment
    marginBelow
    vimeoPosterImage {
      file {
        url
      }
    }
    captionCopy {
      captionCopy
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/case-study.js